(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sitenav', sitenav);

    /* @ngInject */
    function sitenav() {
        var directive = {
            bindToController: true,
            templateUrl: 'sitenav.tpl',
            controller: sitenavCtrl,
            controllerAs: '$ctrl',
            link: link,
            restrict: 'E',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function sitenavCtrl($rootScope, $route, $location, $http) {
        var wScrollTop = window.scrollY, tNav = $('#top-nav'), sNav = $('#sticky-nav');
        $rootScope.$on('throttledScroll', function(e, args) {
            wScrollTop = window.scrollY;
            stickyNav();
        });
        function stickyNav() {
            if(tNav.length < 1) {
                tNav = $('#top-nav');
            }
            if(wScrollTop > tNav.outerHeight()) {
                sNav.addClass('active');
                // console.log('show');
            } else {
                sNav.removeClass('active');
                // console.log('hide');
            }
        }
        // $('.menu-toggle').click(function() {
        //     $('.sticky-menu-mobile').toggleClass('active');
        //     $('.sticky-header').toggleClass('toggled');
        //     if ($('.sticky-menu-mobile').hasClass('active')) {
        //         $("body, html").css({
        //             "overflow": "hidden",
        //             "position": "relative"
        //         });
        //     } else {
        //         $("body, html").css({
        //             "overflow": "auto"
        //         });
        //     }
        // });

        $rootScope.logOut = function() {
            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'logout',
                nonce: $rootScope.stats.nonce
            }).then(function(response) {
                if(response.data.result) {
                    if (angular.isDefined(response.data.redirectUrl)) {
                        $location.url(response.data.redirectUrl);
                    } else {
                        $route.reload();
                    }
                }
            });
        };
    }

})();